// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module--image--3yu7l","title":"styles-module--title--1b2I8","container":"styles-module--container--3J_eH","block":"styles-module--block--Eib6Z"};